import React from 'react';
import Basepage, { BasePageState } from '../Basepage';

import './index.scss';

import img_1 from './parts/images/BB-Landingpage-Grafik_10.svg';
import img_2 from './parts/images/BB-Landingpage-Grafik_05.svg';
import img_3 from './parts/images/BB-Landingpage-Grafik_04.svg';
import img_4 from './parts/images/BB-Landingpage-Grafik_03.svg';
import img_5 from './parts/images/BB-Landingpage-Grafik_06.svg';
import img_6 from './parts/images/BB-Landingpage-Grafik_07.svg';
import img_7 from './parts/images/BB-Landingpage-Grafik_02.svg';
import img_8 from './parts/images/BB-Landingpage-Grafik_09.svg';
import img_9 from './parts/images/BB-Landingpage-Grafik_08.svg';

import Point from './parts/Point';

interface BestState extends BasePageState {}
interface BestModel {}

export default class BestPage extends Basepage<BestState, BestModel> {
  renderChild(): JSX.Element {
    return (
      <div id="best">
        <Point
          number={1}
          text={['BESTELLEN SIE EINFACH ÜBER', 'BARSORTIMENTSGRENZEN HINWEG!']}
          textAditional="Sie benötigen einen Titel, den Ihr Stamm-Barsortiment nicht hat, einfach beim Buchbutler bestellen."
          position="left"
          imageElement={img_1}
        />
        <Point
          number={2}
          text={['KEINE VERTRÄGE,', 'KEINE VERTRAGSBINDUNG']}
          textAditional="Einfach bestellen, wenn Sie etwas benötigen"
          position="right"
          imageElement={img_2}
        />
        <Point
          number={3}
          text={['KEINE MINDESTBESTELLWERTE']}
          textAditional="Um Porto zu sparen können Sie uns auch feste Versandtage vorgeben"
          position="left"
          imageElement={img_3}
        />
        <Point
          number={4}
          text={['BUCHHANDELSRABATT', 'AB DEM 1. STÜCK']}
          position="right"
          imageElement={img_4}
        />
        <Point
          number={5}
          text={['KEINE GEFAHR DER AUSLISTUNG']}
          textAditional="Auch wenn Sie nur gelegentlich beim Buchbutler bestellen"
          position="left"
          imageElement={img_5}
        />
        <Point
          number={6}
          text={['ZAHLUNG AUF OFFENE RECHNUNG', 'ODER PER BAG ABRECHNUNG']}
          position="right"
          imageElement={img_6}
        />
        <Point
          number={7}
          text={['DER BUCHBUTLER LIEFERT', 'NUR VERLAGSNEUE TITEL']}
          position="left"
          imageElement={img_7}
        />
        <Point
          number={8}
          text={['BESTELLEN SIE IMPORT TITEL', 'OHNE ZOLL-PROBLEME']}
          textAditional="Lieferung aus Deutschland mit ausgewiesener MwSt. vom Buchbutler"
          position="right"
          imageElement={img_8}
        />
        <Point
          number={9}
          text={['VERSAND IN IHREM NAMEN']}
          textAditional="Bestücken Sie Ihren Online-Shop mit den Buchbutler Daten"
          position="left"
          imageElement={img_9}
        />
      </div>
    );
  }
  initState(base: BasePageState): BestState {
    let newState: BestState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(checkOnly: boolean): string {
    return this.state.apiBase + '/Standard.php';
  }

  releaseOneCommand(): void {}
  childDidMount(): void {}
  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }

  pageHeaderGetter(): string | null {
    return null;
  }
  pageTitleGetter(): string {
    return 'Buchbutler';
  }
  getBreadCrumb(): JSX.Element {
    return <span></span>;
  }
  getType(): string {
    return 'BestPage';
  }
}
